/* istanbul ignore file */

import './severityIcons.scss';
import WarningIcon from '@mui/icons-material/Warning';

const Warning = () => <WarningIcon sx={{ color: '#feb7a5' }} />;

export default Warning;
